import { getAxiosInstance } from "../utils/axios-api";
import { getAccessToken, createCookie } from "../utils/customMethods";
import {
    SET_USER,
    FETCH_ALL_USERS,
    VERIFY_USER,
    SET_AUTH_INFO,
    GET_REQUESTS,
} from "../actionTypes";
import { CLIENT_AUTHENTICATION } from "../constants";
import { notify } from "../utils/notifications/notifications";

export const verifyUser = creds => async dispatch => {
    const response = await getAxiosInstance().post(`/Login`, creds);

    if (response.status === 200) {
        dispatch({
            type: VERIFY_USER,
            payload: response.data,
        });
    } else {
    }
};

export const validateDevice = reqData => async dispatch => {
    try {
        const response = await getAxiosInstance().post(`/validateDevice`, {
            ...reqData,
            ...CLIENT_AUTHENTICATION,
        });

        if (response.status === 200) {
            dispatch({
                type: VERIFY_USER,
                payload: response.data.user,
            });
            dispatch({
                type: SET_AUTH_INFO,
                payload: response.data.oaAuthTokens,
            });
            createCookie(
                "access_token",
                response.data.oaAuthTokens.access_token,
                response.data.oaAuthTokens.expires
            );
            createCookie(
                "refresh_token",
                response.data.oaAuthTokens.refresh_token,
                15
            );
        } else {
        }
        return response;
    } catch (ex) {
        notify(
            "error",
            "There was an error logging you in. Please try again or contact your site administrator."
        );
        return ex.response;
    }
};

export const registerDevice = reqData => async dispatch => {
    try {
        const response = await getAxiosInstance().post(`/registerDevice`, {
            ...reqData,
            ...CLIENT_AUTHENTICATION,
        });
        if (response.status === 200) {
            dispatch({
                type: VERIFY_USER,
                payload: response.data.user,
            });
            dispatch({
                type: SET_AUTH_INFO,
                payload: response.data.oaAuthTokens,
            });
            createCookie(
                "access_token",
                response.data.oaAuthTokens.access_token,
                response.data.oaAuthTokens.expires
            );
            createCookie(
                "refresh_token",
                response.data.oaAuthTokens.refresh_token,
                15
            );
        } else {
        }
        return response;
    } catch (ex) {
        return ex.response;
    }
};

export const logoutUser = () => async dispatch => {
    try {
        const response = await getAxiosInstance().get(
            `/logout?access_token=${getAccessToken()}`
        );
    } catch (ex) {}
    dispatch({
        type: FETCH_ALL_USERS,
        payload: {},
    });
    dispatch({
        type: VERIFY_USER,
        payload: {},
    });
    dispatch({
        type: SET_AUTH_INFO,
        payload: {},
    });
};

export const loginUser = creds => async dispatch => {
    const response = await getAxiosInstance().post(`/Login`, creds);

    if (response.data.statusCode !== "104") {
        dispatch({
            type: SET_USER,
            payload: response.data,
        });
    }
    return response.data;
};

export const fetchAllUsers = body => async dispatch => {
    const response = await getAxiosInstance().get(
        `/getTimesheetDetails?role=${body.role}&fromDate=${
            body.fromDate
        }&toDate=${body.toDate}&access_token=${getAccessToken()}`
    );

    dispatch({
        type: FETCH_ALL_USERS,
        payload: response.data,
    });
};
